<div class="container mx-auto p-8">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <h4 class="!text-[24px] !font-bold text-[#203D54]">Sub Contractors</h4>
    <!-- Sub Contractors Section -->

    <!-- Sub Contractors Section -->
    <div class="bg-blue-100 p-6 rounded-lg shadow-md mb-8">
      <h2 class="text-xl !text-[24px] !font-bold mb-4 text-[#203D54]">Sub Contractors</h2>
      <div class="mb-4">
        <label
          for="subContractorTitle"
          class="block text-sm font-medium text-gray-700"
          >Title</label
        >
        <input
          type="text"
          id="subContractorTitle"
          formControlName="subContractorTitle"
          class="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          placeholder="Enter Title"
        />
        <div *ngIf="form.get('subContractorTitle')?.touched && form.get('subContractorTitle')?.invalid">
          <span
            *ngIf="form.get('subContractorTitle')?.errors?.['required']"
            class="text-red-500 text-sm"
          >
            Title is required
          </span>
        </div>
      </div>
      <div class="mb-4">
        <label
          for="subContractorDescription"
          class="block text-sm font-medium text-gray-700"
          >Description</label
        >

        <textarea
          id="subContractorDescription"
          formControlName="subContractorDescription"
          rows="6"
          class="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          placeholder="Enter Description"
        ></textarea>
      </div>
      <div class="mb-4">
        <label
          for="subContractorFile"
          class="block text-sm font-medium text-gray-700"
          >Attach Documents</label
        >
        <input
          type="file"
          id="subContractorFile"
          (change)="onFileUpload($event)"
          class="mt-1 block w-full text-sm text-gray-900 border border-gray-300 rounded-md cursor-pointer bg-gray-50 focus:outline-none"
        />
        <div *ngIf="showFileError" class="text-red-500 text-sm">
          File is required.
        </div>
      </div>
    </div>

    <!-- Buttons -->
    <div class="flex justify-end">
      <button
        type="button"
        class="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center mr-[12px]"
      >
        Back
      </button>
      <button
        type="submit"
        class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded inline-flex items-center"
      >
        Save
      </button>
    </div>
  </form>
</div>
